var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "baseInfoManage" },
    [
      _c(
        "el-form",
        {
          ref: "dataForm",
          attrs: {
            model: _vm.childData,
            rules: _vm.rules,
            "label-position": "right",
            inline: "",
            "label-width": "135px"
          }
        },
        [
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "小区名称", prop: "customerType" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "220px" },
                      attrs: {
                        clearable: "",
                        filterable: "",
                        placeholder: "请选择小区名称"
                      },
                      model: {
                        value: _vm.childData.areaGroupId,
                        callback: function($$v) {
                          _vm.$set(_vm.childData, "areaGroupId", $$v)
                        },
                        expression: "childData.areaGroupId"
                      }
                    },
                    _vm._l(_vm.options, function(item) {
                      return _c("el-option", {
                        key: item.dicValue,
                        attrs: { label: item.dicName, value: item.dicValue }
                      })
                    }),
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "租户类别", prop: "customerType" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "220px" },
                      attrs: { clearable: "", placeholder: "请选择租户类别" },
                      on: { change: _vm.resetCustomerType },
                      model: {
                        value: _vm.childData.customerType,
                        callback: function($$v) {
                          _vm.$set(_vm.childData, "customerType", $$v)
                        },
                        expression: "childData.customerType"
                      }
                    },
                    _vm._l(_vm.typeOption, function(item) {
                      return _c("el-option", {
                        key: item.dicValue,
                        attrs: {
                          label: item.dicName,
                          value: parseInt(item.dicValue)
                        },
                        on: { change: _vm.changeTypeValue }
                      })
                    }),
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "租户名称", prop: "customerName" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "220px" },
                    attrs: {
                      clearable: "",
                      type: "text",
                      placeholder: "请输入客户姓名"
                    },
                    model: {
                      value: _vm.childData.customerName,
                      callback: function($$v) {
                        _vm.$set(_vm.childData, "customerName", $$v)
                      },
                      expression: "childData.customerName"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm.childData.customerType !== 2
            ? _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("table.sex"), prop: "userSex" } },
                    [
                      _c(
                        "el-radio-group",
                        {
                          model: {
                            value: _vm.childData.userSex,
                            callback: function($$v) {
                              _vm.$set(_vm.childData, "userSex", $$v)
                            },
                            expression: "childData.userSex"
                          }
                        },
                        _vm._l(_vm.sexOption, function(item) {
                          return _c(
                            "el-radio",
                            {
                              key: item.value,
                              attrs: { label: parseInt(item.dicValue) }
                            },
                            [_vm._v(_vm._s(item.dicName))]
                          )
                        }),
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.childData.customerType === 2
            ? _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("table.companyCreditCode"),
                        prop: "companyCreditCode"
                      }
                    },
                    [
                      _c("el-input", {
                        staticStyle: { width: "220px" },
                        attrs: {
                          type: "text",
                          placeholder: "请输入统一社会信用代码"
                        },
                        model: {
                          value: _vm.childData.companyCreditCode,
                          callback: function($$v) {
                            _vm.$set(_vm.childData, "companyCreditCode", $$v)
                          },
                          expression: "childData.companyCreditCode"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.childData.customerType !== 2
            ? _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "联系电话", prop: "userPhoneOne" } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "220px" },
                        attrs: {
                          clearable: "",
                          type: "text",
                          placeholder: "请输入联系电话"
                        },
                        model: {
                          value: _vm.childData.userPhoneOne,
                          callback: function($$v) {
                            _vm.$set(_vm.childData, "userPhoneOne", $$v)
                          },
                          expression: "childData.userPhoneOne"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.childData.customerType === 2
            ? _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "联系电话", prop: "legalPhoneOne" } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "220px" },
                        attrs: { type: "text", placeholder: "请输入联系电话" },
                        model: {
                          value: _vm.childData.legalPhoneOne,
                          callback: function($$v) {
                            _vm.$set(_vm.childData, "legalPhoneOne", $$v)
                          },
                          expression: "childData.legalPhoneOne"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _vm.childData.customerType !== 2
                ? _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("table.documentType"),
                        prop: "userCardType"
                      }
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "220px" },
                          attrs: {
                            placeholder: "请选择证件类型",
                            clearable: ""
                          },
                          model: {
                            value: _vm.childData.userCardType,
                            callback: function($$v) {
                              _vm.$set(_vm.childData, "userCardType", $$v)
                            },
                            expression: "childData.userCardType"
                          }
                        },
                        _vm._l(_vm.documentOption, function(item) {
                          return _c("el-option", {
                            key: item.dicValue,
                            attrs: {
                              clearable: "",
                              label: item.dicName,
                              value: parseInt(item.dicValue)
                            },
                            on: { change: _vm.changeTowardValue }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          ),
          _vm.childData.customerType !== 2
            ? _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("table.documentNumber"),
                        prop: "userCardSerno"
                      }
                    },
                    [
                      _c("el-input", {
                        staticStyle: { width: "220px" },
                        attrs: {
                          clearable: "",
                          type: "text",
                          placeholder: "请输入证件号码"
                        },
                        model: {
                          value: _vm.childData.userCardSerno,
                          callback: function($$v) {
                            _vm.$set(_vm.childData, "userCardSerno", $$v)
                          },
                          expression: "childData.userCardSerno"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.childData.customerType !== 2
            ? _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "职业名称", prop: "postName" } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "220px" },
                        attrs: {
                          clearable: "",
                          type: "text",
                          placeholder: "请输入职业名称"
                        },
                        model: {
                          value: _vm.childData.postName,
                          callback: function($$v) {
                            _vm.$set(_vm.childData, "postName", $$v)
                          },
                          expression: "childData.postName"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c("el-button", { on: { click: _vm.handCancle } }, [
            _vm._v(_vm._s(_vm.$t("button.cancel")))
          ]),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.handCreate } },
            [_vm._v(_vm._s(_vm.$t("button.confirm")))]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }